import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/tenant/user.tenant.query.gql"
import type {
  UserTenantQuery,
  UserTenantQueryVariables,
} from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.query"

type Options = QueryHookOptions<UserTenantQuery, UserTenantQueryVariables>

export function useUserTenantQuery(options?: Options) {
  return useQuery<UserTenantQuery, UserTenantQueryVariables>(query, options)
}
